import SupportUser from "./support-user.page";

export default SupportUser;
